import React from 'react';
import withContext from '../../ContextAPI/Context_HOC';
import VideoSwitcher from './FundVideoSwitcher';
import FundNotesTable from './FundNotesTable';
import FundNumbers from './FundNumbers';

const FundResources = () => {
  return (
    <>
      <h2 className="yellowBackgroundTextStyle">Ways To Stay Up to Date on the Bahá’í Fund</h2>
      <div className="containerStyle">
        <div className="boxStyle">
          <VideoSwitcher />
          <p>
            <strong>Office of Treasurer Webinar Recordings</strong>
            <br />
            <small>Please do not copy, share, or distribute this video or any sections of the video</small>
          </p>
          <h3>Stay Connected</h3>
          <p>
            Text: 847–733–3472 and in the message box write “Treasurer”
            <br />
            Have questions? After signing up, text 847–733–3472 and in the message box write your question.
          </p>
        </div>
        <FundNumbers />
      </div>
      <hr />
      <FundNotesTable />
    </>
  );
};

export default withContext(FundResources);
